<template>
    <div class="right author-right  pt0">
        <chapterTip>
            <div slot="tip-name">Note</div>
            <div slot="tip-con">
                Before you click the button"Submit",please be sure all necesssary information about the story is correct and compliant with all requirements. Stories with correct information will be approved and published, while those with wrong or indecent content will be rejected and can't be published.
            </div>
            <div slot="tip-btn">
                <el-button v-if="openStatus || openApply && openApply.applyStatus == 2" class="f16 font-MT el-button-opa" size="medium">Success</el-button>
                <div class="flexible aItem-center">
                    <el-button v-if="!openStatus && !openApply||openApply && openApply.applyStatus == -2" class="f16 font-MT" type="success" size="medium" @click="openBook()">Submit</el-button>
                     <el-popover
                            placement="top"
                            title=""
                            width="280"
                            popper-class="contract-pop"
                            v-if="openApply && openApply.applyStatus == -2"
                            trigger="hover"
                            :content="openApply&&openApply.comment">
                        <i v-if="openApply && openApply.applyStatus == -2" slot="reference" class="el-icon-warning text-danger ml0" style="font-size: 25px;"></i>
                    </el-popover>
                </div>
                <el-button v-if="openApply&&openApply.applyStatus == 1" class="f16 font-MT" type="info" size="medium">Submitted</el-button>
            </div>
        </chapterTip>
    </div>
</template>

<script>
    import { publishBook } from "apiurl/author";
    export default {
        name: "",
        props: {
            bookdetail: Object,
        },
        data () {
            return {
                openStatus: null,
                openApply: null
            }
        },
        watch: {
            bookdetail (n) {
                this.openStatus = this.bookdetail.open
                this.openApply = this.bookdetail.openApply?this.bookdetail.openApply:null
            },
        },
        mounted() {
            this.openStatus = this.bookdetail.open
            this.openApply = this.bookdetail.openApply?this.bookdetail.openApply:null
        },
        methods: {
            openBook() {
                publishBook(this.$route.params.id)
                    .then(res => {
                        if (res.success) {
                            this.$success('custom', res.message)
                            if (!this.openApply) {
                                this.openApply = {}
                            }
                            this.$set(this.openApply, 'applyStatus', 1)
                        }
                    })
                    .catch(() => {});
            },
        }
    }
</script>

<style lang="scss">
    .contract-pop{
        background: rgba(0,0,0,0.8)!important;
        color: #fff;
        font-size: 16px!important;
        font-family: Arial!important;
        line-height: 26px!important;
        border-radius: 12px!important;
        .popper__arrow,.popper__arrow::after{
            border-top-color: #000!important;
        }

    }
</style>
